<template>
  <div class="">
    <div class="flex flex-wrap justify-center">
      <div
        v-for="(player, index) of players"
        :key="index"
        class="rounded-lg bg-gray-100 m-2   shadow  "
      >
        <div class="text-center py-2 ">
          <span class="tag-player large-tag " :class="'color-' + player.color">
            {{ player.name }}</span
          >
        </div>

        <div v-for="(line, index) of score.settings.scoresheet" :key="index">
          <ModalEasyScore
            :initDetail="getScore(player.name, line.label)"
            @update="calculTotal(player.name)"
            @showModal="modalScore = true"
            @hideModal="modalScore = false"
            :backGroundColor="player.color"
            :showLineScore="score.settings.scoresheet.length > 1"
          />
        </div>

        <div
          class="button scoreTotal"
          :class="'color-' + player.color"
        >
          <span v-if="player.total"> {{ player.total }}</span>
          <span v-else class="opacity-10">-</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//import ModalColorPicker from "@/components/ui/custom/ModalColorPicker.vue";
//import ColorRound from "@/components/ui/generic/fragments/ColorRound.vue";
import ModalEasyScore from "@/components/ui/custom/ModalEasyScore.vue";
//import PrimaryButton from "@/components/ui/form/button/PrimaryButton.vue";
//import SecondaryButton from "@/components/ui/form/button/SecondaryButton.vue";
//import TertiaryButton from "@/components/ui/form/button/TertiaryButton.vue";

export default {
  name: "score",
  props: {
    score: {}
  },
  data() {
    return {
      modalScore: false
    };
  },

  components: {
    //    ModalColorPicker,
    //    ColorRound,
    ModalEasyScore
    //    PrimaryButton,
    //    SecondaryButton,
    //    TertiaryButton
  },

  methods: {
    startGame: function() {},
    initScore: function() {
      //console.info('initScore');
      for (var line = 0; line < this.score.settings.scoresheet.length; line++) {
        for (var player = 0; player < this.score.players.length; player++) {
          // this.score.line.player = "";
          this.score.details.push({
            line: this.score.settings.scoresheet[line].label,
            player: this.score.players[player].name,
            score: ""
          });
          //this.score.{line.label}[player.name] = '';
        }
      }
    },
    initPlayerScore: function(playerName) {
      for (var line = 0; line < this.score.settings.scoresheet.length; line++) {
        // this.score.line.player = "";
        this.score.details.push({
          line: this.score.settings.scoresheet[line].label,
          player: playerName,
          score: ""
        });
        //this.score.{line.label}[player.name] = '';
      }
    },
    removePlayer: function(playerName) {
      this.score.details = this.excludeScoreByPlayerName(playerName);
    },
    calculTotal(playerName) {
      let total = 0;
      let score_player = this.filterScoreByPlayerName(playerName);
      let player = this.filterPlayerByPlayerName(playerName);

      for (var i = 0; i < score_player.length; i++) {
        total += Number(score_player[i].score);
      }
      if (!isNaN(total)) {
        this.$set(player[0], "total", total);

        return total;
      } else {
        this.$set(player[0], "total", "");
        return "";
      }
      //.toLocaleString('fr-fr');
    },
    getScore: function(playerName, lineLabel) {
      let index = this.getScoreIndex(playerName, lineLabel);
      //this.calculTotal(playerName);
      //console.info(index);
      if (index >= 0) {
        //console.dir(this.score.details[index]);
        return this.score.details[index];
      } else {
        return { score: "" };
      }
    },
    filterPlayerByPlayerName(playerName) {
      return this.score.players.filter(function(item) {
        return item.name === playerName;
      });
    },
    filterScoreByPlayerName(playerName) {
      return this.score.details.filter(function(item) {
        return item.player === playerName;
      });
    },
    excludeScoreByPlayerName(playerName) {
      return this.score.details.filter(function(item) {
        return item.player != playerName;
      });
    },
    getScoreIndex: function(playerName, lineLabel) {
      if (playerName && lineLabel) {
        // Search index if no create it
        let index = this.getIndex(playerName, lineLabel);
        if (index >= 0) {
          return index;
        } else {
          //this.initPlayerScore(playerName);
          this.score.details.push({
            line: lineLabel,
            player: playerName,
            score: ""
          });

          // retrieve the newLine
          index = this.getIndex(playerName, lineLabel);
          return index;
        }
      }
    },
    getIndex: function(playerName, lineLabel) {
      return this.score.details.findIndex(function(item) {
        return item.line === lineLabel && item.player === playerName;
      });
    },
    updateScore: function(playerName, lineLabel, event) {
      // let  result = Number(event.target.value)
      let result = Number;
      if (!isNaN(event.target.value)) {
        result = Number(event.target.value);
      } else {
        result = 0;
      }
      let current = this.getScoreIndex(playerName, lineLabel);
      if (current >= 0) {
        this.score.details[current].score = result.toString();
      }
      this.calculTotal(playerName);
    }
  },
  computed: {
    Score: function(name, line) {
      return this.getScore(name, line).score.toString();
    },
    players() {
      return this.score.players;
    }
  },
  mounted() {
    /*
    if (localStorage.getItem("skor_settings")) {
      this.settings = JSON.parse(localStorage.getItem("skor_settings"));
    }
    if (localStorage.getItem("skor_players")) {
      this.players = JSON.parse(localStorage.getItem("skor_players"));
    }
    if (localStorage.getItem("skor_score")) {
      this.score = JSON.parse(localStorage.getItem("skor_score"));
    } else {
      //this.initScore();
    }*/
  },
  watch: {
    score: {
      handler() {
        //console.info("Score modifié");
        // localStorage.setItem("skor_score", JSON.stringify(this.score));
      },
      deep: true
    }
  }
};
</script>
